const CONFERENCE_MODE_KEY = 'conference_mode';

/** Routes booth visitors may open during a conference demo session. */
export const CONFERENCE_ALLOWED_PREFIXES = [
  '/coverage-risk',
  '/dis-enrollment-risk',
  '/kmc-select-report',
  '/aiq-ai',
  '/aiq/queue',
  '/aiq/485',
  '/aiq/insurance-coverage',
  '/aiq/clinical-notes',
  '/plan-coverage-query',
  '/ecp/485-extraction',
  '/ecp/import',
  '/iq-hub',
  '/state-iq',
  '/converging-signals',
  '/what-if-iq',
  '/docket-iq',
  '/pollie-packets',
  '/briefings',
  '/policy-engine',
  '/resource-navigator',
  '/internal/feedback',
  // Public member-facing pages (must work even during booth demo sessions)
  '/legislative-watch',
  '/action',
  '/secure-upload',
];

export function isConferenceMode() {
  try {
    return sessionStorage.getItem(CONFERENCE_MODE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setConferenceMode(active = true) {
  try {
    if (active) {
      sessionStorage.setItem(CONFERENCE_MODE_KEY, '1');
    } else {
      sessionStorage.removeItem(CONFERENCE_MODE_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function clearConferenceMode() {
  setConferenceMode(false);
}

export function isConferenceRoute(path) {
  if (!path || path === '/') return true;
  return CONFERENCE_ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export async function startNextVisitor() {
  clearConferenceMode();
  const auth = (await import('./auth')).default;
  const { clearAssumedOrg } = await import('./assumedOrg');
  clearAssumedOrg();
  auth.logout();
  window.location.href = '/visit.html';
}
